import { render, staticRenderFns } from "./SettingYearlyForm.vue?vue&type=template&id=4b74ab01&"
import script from "./SettingYearlyForm.vue?vue&type=script&lang=js&"
export * from "./SettingYearlyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports